import { render, staticRenderFns } from "./CuestionarioBloque.vue?vue&type=template&id=65a73594&scoped=true"
import script from "./CuestionarioBloque.vue?vue&type=script&lang=js"
export * from "./CuestionarioBloque.vue?vue&type=script&lang=js"
import style0 from "./CuestionarioBloque.vue?vue&type=style&index=0&id=65a73594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a73594",
  null
  
)

export default component.exports